<template>
  <div>
    <div v-if="!showWidgetSettings">
      <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-link-variant"></v-icon>
      </v-col>

      <v-col style="word-break: break-all" class="d-flex flex-column align-center">
        <span>Гиперссылка</span>
      </v-col>
    </div>
    <div v-else>
      <v-form @submit.prevent="save" ref="form">
        <v-row>
          <v-col cols="12" md="8">
            <v-text-field variant="underlined" v-model="linkName" :rules="rules.linkName" label="Название ссылки"
              onautocomplete="off"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field variant="underlined" v-model="selectedIcon" label="Иконка" @click="iconSelectDialog = true">
              <template v-slot:append-inner>
                <v-icon icon="mdi-panorama-variant" />
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-text-field variant="underlined" v-model="url" :rules="rules.isURL" label="URL"
          onautocomplete="off"></v-text-field>
        <v-btn :disabled="saveButtonReadOnly" text="Сохранить" type="submit" class="ma-4"></v-btn>
      </v-form>
    </div>
    <v-dialog v-model="iconSelectDialog" max-width="450" persistent>
      <v-card>
        <v-card-text>
          <v-text-field v-model="searchIcon" placeholder="Search icon" prepend-icon="mdi-magnify" type="text"
            onautocomplete="off" dense />

          <v-virtual-scroll :items="showedIcons" height="400">
            <template v-slot:default="{ item }">
              <span class="mr-2 mb-2" v-for="(icon, i) in item" :key="i">
                <v-btn @click="saveIcon(icon)" variant="text" density="compact" :icon="`mdi-` + icon"></v-btn>
              </span>
            </template>
          </v-virtual-scroll>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text="Закрыть" @click="iconSelectDialog = false"></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  emits: ["widgetAdd"], //обязательный для всех виджетов
  props: {
    //обязательный для всех виджетов.клик по иконке. нужно открыть доп. настройки
    //или заэмитить widgetAdd
    showWidgetSettings: {
      required: true,
    },
  },
  name: "HyperLinkSettings",
  data() {
    return {
      linkName: "",
      url: "",
      selectedIcon: "",
      iconSelectDialog: false,
      searchIcon: "",
      allIcons: [],
      showedIcons: [],
      saveButtonReadOnly: false,
      rules: {
        linkName: [
          (value) => {
            if (value?.length < 3) {
              return "Имя должно содержать хотя бы 3 символа";
            }
            
            if(value.match(/[^A-Za-z0-9 А-Яа-я]/)){
              return "Недопустимые символы";
            }
            return true;
          },
        ],
        isURL: [
          (value) => !!value || "Required.",
          (value) => this.isURL(value) || "URL is not valid",
        ],
      },
    };
  },
  watch: {
    searchIcon: function (oldSearchIcon, newSearchIcon) {
      let filteredIcons = [];
      if (this.searchIcon.length === 0) {
        filteredIcons = this.allIcons;
      } else {
        filteredIcons = this.allIcons.filter((i) =>
          i.includes(this.searchIcon)
        );
      }
      this.showedIcons = [];
      for (let i = 0; i < filteredIcons.length; i += 10) {
        this.showedIcons.push(filteredIcons.slice(i, i + 10));
      }
    },
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot +
        "/procollege/psm_desktop2/widgets/hyperlink/getAllIcons"
      )
      .then((response) => {
        this.allIcons = response.data;
        for (let i = 0; i < this.allIcons.length; i += 10) {
          this.showedIcons.push(this.allIcons.slice(i, i + 10));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    save() {
      this.$refs.form.validate().then(({ valid: isValid }) => {
        if (isValid) {
          this.saveButtonReadOnly = true;
          this.$emit("widgetAdd", {
            url: this.url,
            name: this.linkName,
            icon: this.selectedIcon,
          });
        }
      });
    },
    saveIcon: function (icon) {
      this.searchIcon = "";
      this.selectedIcon = "mdi-" + icon;
      this.iconSelectDialog = false;
    },
    isURL(str) {
      let url;

      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }

      return url.protocol === "http:" || url.protocol === "https:";
    },
  },
};
</script>
